import ClientsAxios from "../../client-axios";
import { ListResponseType, ResponseEntity } from "../../dto/response";
import { EmailDocsRequest, InvoiceType } from "../../dto/response/export-docs/invoice";
import { InvoiceListResponse } from "../../dto/response/invoice/invoice";

const { API_SERVER } = ClientsAxios;

export const StoreInvoiceService = async (payload: any) => {
    const responseEntity = new ResponseEntity()
    try {
        const response = await API_SERVER.post('invoice/store', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}
export const UpdateInvoiceService = async (payload: any) => {
    const responseEntity = new ResponseEntity()
    try {
        const response = await API_SERVER.post('invoice/update', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const UpdateInvoiceStatusService = async (payload: any) => {
    const responseEntity = new ResponseEntity()
    try {
        const response = await API_SERVER.post('invoice/status-update', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}


export const FetchInvoiceDetailsService = async (payload: { uuid: string }) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('invoice/details', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchDynamicFieldsListService = async ({}) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('dynamic-field/list', {})
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}


export const FetchInvoiceListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<ListResponseType<InvoiceType>>()
    try {
        const response = await API_SERVER.post('invoice/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchMappedInvoiceListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<ListResponseType<InvoiceType>>()
    try {
        const response = await API_SERVER.post('irm/mapped-invoice-list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchInvoiceService = async (payload: any) => {
    const responseEntity = new ResponseEntity<InvoiceListResponse>()
    try {
        const response = await API_SERVER.post('invoice/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}


export const DeleteInvoiceService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('invoice/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchInvoiceDocumentBlobService = async (payload: { id: number }, options: { signal?: AbortSignal } = {}) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('invoice/pdf', payload, {
            responseType: 'blob',
            signal: options.signal,
        });
        responseEntity.success(response, 200, "Success");
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data || {});
    }
    return responseEntity;
};

export const EmailDocsService = async (payload: EmailDocsRequest) => {
    const responseEntity = new ResponseEntity<{message: string}>();
    try {
        const response = await API_SERVER.post(`email/documents`, payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}
